<template>
    <div class="p-2.5 mr-2.5 ml-2.5">{{skill}}</div>
</template>

<script>
module.exports = {
    props: ['skill']
}
</script>
